import GreenhouseGoalTermProvider from './GreenhouseGoalTermProvider';

export default GreenhouseGoalTermProvider;
